"use client"

import { ReactNode } from "react"
import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu"

import { cn } from "@/utils/cn"

interface DropdownProps {
  trigger: ReactNode
  children: ReactNode
  className?: string
}

export function Dropdown({ trigger, children, className }: DropdownProps) {
  return (
    <DropdownMenuPrimitive.Root data-slot="dropdown-menu">
      <DropdownMenuPrimitive.Trigger
        suppressHydrationWarning
        data-slot="dropdown-menu-trigger group"
      >
        {trigger}
      </DropdownMenuPrimitive.Trigger>
      <DropdownMenuPrimitive.Portal>
        <DropdownMenuPrimitive.Content
          data-slot="dropdown-menu-content"
          side="bottom"
          className={cn(
            "z-50 min-w-[8rem] overflow-x-hidden overflow-y-auto data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95",
            className
          )}
        >
          {children}
        </DropdownMenuPrimitive.Content>
      </DropdownMenuPrimitive.Portal>
    </DropdownMenuPrimitive.Root>
  )
}
